import React, { useState } from 'react';

const CartSidebar = ({
  cart,
  onQuantityChange,
  onRemoveItem,
  onNoteChange,
  subtotal,
  cartOpen,
  setCartOpen,
  onSubmitOrder,
  existingOrder
}) => {
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState('');

  const handleEditStart = (item) => {
    setEditingId(item._id);
    setEditValue(item.qty.toString());
  };

  const handleEditSave = (item) => {
    const newQty = parseInt(editValue) || 1;
    onQuantityChange(item._id, newQty);
    setEditingId(null);
  };

  const handleKeyDown = (e, item) => {
    if (e.key === 'Enter') {
      handleEditSave(item);
    }
  };

  const handleSubmit = () => {
    onSubmitOrder(); // Just trigger the parent's submission
  };

  return (
    <div className={`w-96 bg-white shadow-lg transition-all duration-300 ${cartOpen ? 'translate-x-0' : 'translate-x-full'}`}>
      <div className="p-4 h-screen flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Order Summary</h2>
          <button 
            onClick={() => setCartOpen(false)}
            className="text-gray-500 hover:text-gray-700"
          >
            &times;
          </button>
        </div>

        <div className="flex-1 overflow-y-auto">
          {cart.length === 0 ? (
            <p className="text-gray-500 text-center py-8">Your cart is empty</p>
          ) : (
            <ul className="divide-y divide-gray-200">
              {cart.map((item) => (
                <li key={item._id} className="py-3">
                  <div className="flex justify-between items-center">
                    <div className="flex-1">
                      <h3 className="font-medium">{item.name}</h3>
                      <p className="text-gray-600">{item.price.toFixed(2)}</p>
                    </div>
                    
                    <div className="flex items-center space-x-2">
                      <button 
                        onClick={() => onQuantityChange(item._id, item.qty - 1)}
                        className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center hover:bg-gray-300"
                        disabled={item.qty <= 1}
                      >
                        -
                      </button>
                      
                      {editingId === item._id ? (
                        <input
                          type="number"
                          min="1"
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                          onBlur={() => handleEditSave(item)}
                          onKeyDown={(e) => handleKeyDown(e, item)}
                          autoFocus
                          className="w-12 text-center border rounded py-1"
                        />
                      ) : (
                        <div 
                          onClick={() => handleEditStart(item)}
                          className="w-12 text-center border rounded py-1 cursor-pointer hover:bg-gray-50"
                        >
                          {item.qty}
                        </div>
                      )}
                      
                      <button 
                        onClick={() => onQuantityChange(item._id, item.qty + 1)}
                        className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center hover:bg-gray-300"
                      >
                        +
                      </button>
                    </div>
                  </div>
                  
                  <div className="mt-2 flex items-center">
                    <input
                      type="text"
                      placeholder="Add note..."
                      value={item.note}
                      onChange={(e) => onNoteChange(item._id, e.target.value)}
                      className="flex-1 border rounded px-2 py-1 text-sm"
                    />
                    <button
                      onClick={() => onRemoveItem(item._id)}
                      className="ml-2 text-red-500 hover:text-red-700"
                    >
                      Remove
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="border-t pt-4">
          <div className="flex justify-between mb-4">
            <span className="font-semibold">Subtotal:</span>
            <span>{subtotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
          </div>
          
          <button
            onClick={handleSubmit}
            disabled={cart.length === 0}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded"
          >
            {existingOrder ? 'Update Order' : 'Submit Order'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartSidebar;